import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import useStore from "@/hooks/useStore";
import { motion } from "framer-motion";
import { usePadding } from "@/components/utils/Padding";
import "./styles.scss";

/* #META
 {
  "NAME": "Columns",
  "CLASSNAME": "columns-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const Columns = ({ data }) => {
  const { column_cards, columns_type, open_roles, padding_component } = data;
  const { cards } = column_cards || {};
  const numberOfCards = cards.length;
  const [openRolesPosts, setOpenRolesPosts] = useState();
  const { getItems, requestedItems } = useStore();

  const openRolesRequest = {
    type: "open-roles",
    params: {
      _embed: 1,
      order: "desc",
      orderby: "date",
      per_page: 3,
    },
    showLoading: true,
  };

  const getOpenRoles = () => {
    async function fetchData() {
      await getItems(openRolesRequest);
      setOpenRolesPosts(requestedItems(openRolesRequest));
    }
    fetchData();
  };

  useEffect(() => {
    if (columns_type === "open-roles") {
      getOpenRoles();
    }
  }, [columns_type]);

  const paddingStyle = usePadding(padding_component);

  return (
    <section className="columns-component container-revamp" style={paddingStyle}>
      {columns_type === "columns" ? (
        <div
          className="columns-content"
          style={{
            gridTemplateColumns: `repeat(${numberOfCards}, 1fr)`,
          }}
        >
          {cards &&
            cards.map((card, index) => {
              const { content, title } = card;
              const cardNumber = (index + 1).toString().padStart(2, "0");

              return (
                <motion.div
                  key={index}
                  className="card"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    damping: 20,
                    delay: index * 0.3,
                  }}
                  viewport={{ once: true, amount: 0.2 }}
                >
                  {card?.title_format === "numbers" ? (
                    <span>{cardNumber}</span>
                  ) : (
                    title && (
                      <div className="card-title" dangerouslySetInnerHTML={{ __html: title }} />
                    )
                  )}
                  <div className="card-content" dangerouslySetInnerHTML={{ __html: content }} />
                </motion.div>
              );
            })}
        </div>
      ) : (
        <div className="open-roles-container">
          {open_roles?.open_label && (
            <p className={`open-label open-label-${open_roles?.label_color}`}>
              {open_roles?.open_label}
            </p>
          )}
          {open_roles?.open_title && (
            <div
              className="open-title"
              dangerouslySetInnerHTML={{ __html: open_roles?.open_title }}
            />
          )}

          <div className="open-roles-cards">
            {openRolesPosts?.length > 0 ? (
              openRolesPosts?.map((post, index) => {
                const imageData = post._embedded?.["wp:featuredmedia"]?.[0];
                const imageUrl = imageData?.source_url || "";
                const imageAlt = imageData?.alt_text || post.title.rendered;

                return (
                  <motion.div
                    className="card-container"
                    key={post.id}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{
                      type: "spring",
                      stiffness: 100,
                      damping: 20,
                      delay: index * 0.5,
                    }}
                    viewport={{ once: true, amount: 0.2 }}
                  >
                    <div className="card-image">
                      <img alt={imageAlt} src={imageUrl} />
                    </div>
                    <div className="card-content">
                      <h4
                        className="title"
                        dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                      />
                      <div className="card-content-link">
                        <a className="" href={post?.link}>
                          Apply Now
                        </a>
                        <span className="icon">
                          <svg
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.667 7.834 14.134 2.367"
                              stroke="#FD6A75"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14.667 5.034V1.834h-3.2"
                              stroke="#FD6A75"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.333 1.834H6C2.667 1.834 1.333 3.167 1.333 6.501v4c0 3.333 1.334 4.667 4.667 4.667h4c3.333 0 4.667-1.334 4.667-4.667v-1.334"
                              stroke="#FD6A75"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </motion.div>
                );
              })
            ) : (
              <p className="h4-black text-2xl text-white pt-5">
                No open roles available at the moment.
              </p>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

Columns.propTypes = {
  data: PropTypes.shape({
    acf_fc_layout: PropTypes.string,
    columns_type: PropTypes.oneOf(["columns", "open-roles"]),
    padding_component: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
    column_cards: PropTypes.shape({
      cards: PropTypes.arrayOf(
        PropTypes.shape({
          title_format: PropTypes.oneOf(["numbers", "text"]),
          title: PropTypes.string,
          content: PropTypes.string,
        })
      ),
    }),

    open_roles: PropTypes.shape({
      open_label: PropTypes.string,
      label_color: PropTypes.string,
      open_title: PropTypes.string,
    }),
  }),
};

export default Columns;
